module.exports = __webpack_public_path__ + "img/georgievsk_excursions.08ca7462.jpeg";